function e() {
  return null;
}
export {
  e as default
};
//# sourceMappingURL=index.es37.js.map
